<template>
  <div class="page-404">
    <h1>404</h1>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss">
  
</style>
